import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ParentCustomSuperTab } from './parentcustomsupertab';
import { ParentCustomSuperTabsToolbar } from './parentcustom-supertabtoolbar';
import { ParentCustomSuperTabButton } from './parentcustom-super-tab-button';
import { ParentCustomSuperTabsController } from './parentcustomsupertabscontroller';
import { ParentCustomSuperTabs } from './parentcustomsupertabs';
import { ParentCustomSuperTabsContainer } from './parentcustomsupertabscontainer';

@NgModule({
  declarations: [
    ParentCustomSuperTab,
    ParentCustomSuperTabs,
    ParentCustomSuperTabsToolbar,
    ParentCustomSuperTabsContainer,
    ParentCustomSuperTabButton
  ],
  imports: [
    IonicModule],
  exports: [
    ParentCustomSuperTab,
    ParentCustomSuperTabs
  ]
})
export class ParentCustomSuperTabsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ParentCustomSuperTabsModule,
      providers: [
        ParentCustomSuperTabsController
      ]
    };
  }
}